import React, {Component} from 'react';
import MessageBox from '../../Common/MessageBox';
import queryString from 'query-string';

class PasswordResetResult extends Component {
  componentDidMount() {}

  render() {
    let queryParams = queryString.parse(this.props.location.search);
    let maskedEmailAddress = queryParams ? queryParams.maskedEmailAddress : undefined;
    if (maskedEmailAddress) {
      return (
        <div>
          <MessageBox>
            <p className="inquiry2">
              가입 시 등록하셨던 이메일 <b>{maskedEmailAddress}</b> 으로
              <br />
              임시 비밀번호가 발송되었습니다.
            </p>
          </MessageBox>
        </div>
      );
    } else {
      return (
        <div>
          <MessageBox>
            <p>
              <b>입력하신 정보와 일치하는 데이터가 없습니다.</b>
            </p>
          </MessageBox>
        </div>
      );
    }
  }
}

export default PasswordResetResult;
